export default {"src":"/_next/static/image/components/ui/Icon/icons/work.1a90bb283adfea1a1a3309891faa7ee1.svg","height":22,"width":22};